/** A test counts as filled in when its value is non-empty after trimming (0 included). */
export function hasObservationValue(value) {
  if (value === 0 || value === "0") return true;
  if (value === undefined || value === null) return false;
  return String(value).trim().length > 0;
}

/**
 * Keeps only the tests the doctor actually entered a value for, and drops
 * panels left entirely empty. All other panel/test fields are preserved so the
 * result can be rendered directly (code, unit, group_name, ...).
 */
export function getPanelsWithObservationValues(panelData) {
  if (!Array.isArray(panelData)) return [];

  return panelData
    .map((panel) => ({
      ...panel,
      tests: (panel?.tests || []).filter((test) =>
        hasObservationValue(test?.value),
      ),
    }))
    .filter((panel) => panel.tests.length > 0);
}

/**
 * Used when building consultation / save payloads. Returns only panels where
 * at least one test has a non-empty value, and each test as the legacy shape
 * { test, code, value, unit } (no UI-only fields).
 */
export function filterInitialObservationForClinicalPayload(panelData) {
  return getPanelsWithObservationValues(panelData).map((panel) => ({
    panel_name: panel.panel_name,
    tests: panel.tests.map((t) => ({
      test: t.test,
      code: t.code,
      value: t.value,
      unit: t.unit,
    })),
  }));
}
